import axios from 'axios';
export const EVALUATION_PERIODS = 'v3/evaluation_period';

export function getEvaluationPeriods() {
  return axios.get(EVALUATION_PERIODS);
}

export function createEvaluationPeriod(params) {
  return axios.post(EVALUATION_PERIODS, params);
}

export function deleteEvaluationPeriod(params) {
  return axios.delete(EVALUATION_PERIODS + '/' + params.id);
}

export function updateEvaluationPeriod(params) {
  return axios.put(EVALUATION_PERIODS, params);
}

export function getEvaluationPeriodsSystem() {
  return axios.get('v3/sys/evaluation_periods');
}
